// apps/client/src/ui/kit/Button.tsx
import type { ReactNode } from 'react';
export function Button(p: { variant?: 'primary' | 'quiet'; disabled?: boolean; type?: 'button' | 'submit'; onClick?: () => void; children: ReactNode }) {
  return <button type={p.type ?? 'button'} className={`btn btn-${p.variant ?? 'primary'}`} disabled={p.disabled} onClick={p.onClick}>{p.children}</button>;
}
